import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CNavLink } from "./c/CHeader";
import useTranslations from "sdk/custom-hooks/useTranslations";
import { MOBILE_MAX_WIDTH } from '../../../constants/breakpoints';
import MenuIcon from '@material-ui/icons/Menu';
import {IconButton, Typography, Box, Link, withStyles, Tooltip, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import classNames from 'classnames';
import LmsHeaderLogo from "../../../assets/images/learnifyLightLogo.svg";
import { ReactComponent as DashboardIconDark } from "../../../assets/images/dashboardIconDark.svg";
import { ReactComponent as DashboardIconLight } from "../../../assets/images/dashboardIconLight.svg";
import { ReactComponent as AllCoursesIconDark } from "../../../assets/images/allCoursesIconDark.svg";
import { ReactComponent as AllCoursesIconLight } from "../../../assets/images/allCoursesIconlight.svg";
import { ReactComponent as MyCoursesIconDark } from "../../../assets/images/myCoursesIconDark.svg";
import { ReactComponent as MyCoursesIconLight } from "../../../assets/images/myCoursesIconLight.svg";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { ReactComponent as SurveyIconDark } from "../../../assets/images/surveyIconDark.svg";
import { ReactComponent as SurveyIconLight } from "../../../assets/images/surveyIconLight.svg";
import { ReactComponent as SupportIconDark } from "../../../assets/images/supportIconDark.svg";
import { ReactComponent as SupportIconLight } from "../../../assets/images/supportIconLight.svg";
import './Header.scss';
import { useHistory, useLocation } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ColorsConstant } from '../../../constants/colorConstant';
import { useDispatch, useSelector } from 'react-redux';
import { getUserCourseGroup } from 'sdk/actions';
import status from "sdk/constants/actionStatus.js";
import MenuBookIcon from '@material-ui/icons/MenuBook';

/**
 * Single menu component
 * @param props
 * @returns {*}
 * @constructor
 */
function SingleMenu(props) {
  const t = useTranslations();
  const location = useLocation();

  const {
    to,
    href,
    openDrawerStatus,
    screenWidth,
    handleDrawerClose,
    title,
    titleKey,
    icon,
    setSelectedMenu,
    selectedIcon,
    isExact,
    target
  } = props;
  const isSelected = location.pathname === to;
  return (
    <CNavLink to={to} href={href} isExact={isExact} target={target}>
      <Tooltip
        placement="right-end"
        title={openDrawerStatus ? "" : t(titleKey)}
        aria-label={title}
      >
        <ListItem
          onClick={() => {
            if (screenWidth && screenWidth <= MOBILE_MAX_WIDTH) {
              handleDrawerClose();
            }
            if (setSelectedMenu) {
              setSelectedMenu(to);
            }
          }}
        >
          <ListItemIcon>{isSelected ? selectedIcon : icon}</ListItemIcon>
          <ListItemText
            primary={t(titleKey)}
            disableTypography
            style={{fontSize: "16px" }}
          />
        </ListItem>
      </Tooltip>
    </CNavLink>
  );
}

/**
 * Top menu list for web app
 * @param props
 * @returns {*}
 * @constructor
 */
function TopMenuList(props) {
  const { classes, openDrawerStatus, handleDrawerOpen } = props;
  const dispatch = useDispatch();
  const [isCourseSubMenuOpen, setIsCourseSubMenuOpen] = useState(true);
  const settings = useSelector((state) => state.settingsReducers);
  const user = useSelector((state) => state.user);
  const isLoadingSettings = settings.status === status.PENDING;
  const settingsData = settings.settingsData?.data || [];
  const [dynamicLogos, setDynamicLogos] = useState('');
  const [hasCoursePackages, setHasCoursePackages] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("/dashboard");
  const userId = user?.user?._id ? user?.user?._id : user?._id;
  const t = useTranslations();
  localStorage.setItem('openDrawerStatus',openDrawerStatus)

  const history = useHistory();

  useEffect(() => {
    if (!isLoadingSettings) {
    const imageValue = settingsData?.data?.[0]?.branding?.logos?.webAndAppLogo?.imagePath;
    setDynamicLogos(imageValue || LmsHeaderLogo);
    }
  }, [isLoadingSettings, settingsData])

  useEffect(() => {
    const savedMenu = localStorage.getItem('selectedMenu');
    setSelectedMenu(savedMenu || "/dashboard");
  }, []);

  useEffect(() => {
    localStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  useEffect(() => {
    const fetchCoursePackages = async () => {
      if (!userId) {
        setHasCoursePackages(false);
        return;
      }

      try {
        const response = await Promise.resolve(dispatch(getUserCourseGroup(userId, 0, 1)));
        setHasCoursePackages(Array.isArray(response?.data) && response.data.length > 0);
      } catch (error) {
        console.error('Failed to fetch course packages', error);
        setHasCoursePackages(false);
      }
    };

    fetchCoursePackages();
  }, [dispatch, userId]);

  return (
    <React.Fragment>
      {
        <>
          <Box
            className="drawer-left-head"
            id='drawerLeftHeadId'>
            {openDrawerStatus && (
              <Box className={classNames(
                classes.HeaderMenuButton,
                openDrawerStatus
              )}>
                <Typography
                  className="logo-main"
                  variant="h6"
                  noWrap
                >
                  {dynamicLogos && (
                    <IconButton aria-label="Go to dashboard" onClick={() => history.push('/dashboard')}>
                      <img src={dynamicLogos} alt="LMS logo" />
                    </IconButton>
                  )}
                  <ArrowBackIcon className={"arrow-icon"} onClick={(e) => { handleDrawerOpen(e); setIsCourseSubMenuOpen(!isCourseSubMenuOpen) }} />
                </Typography>
              </Box>
            )}
            {!openDrawerStatus && (
              <IconButton
                aria-label="Open drawer"
                onClick={(e) => {
                  handleDrawerOpen(e);
                  setIsCourseSubMenuOpen(!isCourseSubMenuOpen)
                }}
                className={classNames(
                  classes.HeaderMenuButton,
                  openDrawerStatus
                )}
              >
                <MenuIcon className={"menu-icon"} />
              </IconButton>
            )}
          </Box>
          <Box className={classes.navMenus}>
            <Box className="nav-menus">
            <SingleMenu
              setSelectedMenu={setSelectedMenu}
              to="/dashboard"
              title="Dashboard"
              titleKey="dashboard"
              isExact={true}
              icon={<DashboardIconDark/>}
              selectedIcon={<DashboardIconLight/>}
              {...props}
            />
            <SingleMenu
              setSelectedMenu={setSelectedMenu}
              to="/courses"
              title="Courses"
              titleKey="COURSES"
              isExact={false}
              icon={<AllCoursesIconDark/>}
              selectedIcon={<AllCoursesIconLight/>}
              {...props}
            />
            {hasCoursePackages && (
              <SingleMenu
                setSelectedMenu={setSelectedMenu}
                to="/course-package"
                title="CoursePackage"
                titleKey="Course Packages"
                isExact={false}
                icon={<LibraryBooksIcon/>}
                selectedIcon={<LibraryBooksIcon/>}
                {...props}
              />
            )}

              <SingleMenu
                setSelectedMenu={setSelectedMenu}
                to="/my-courses"
                title="MyCourse"
                titleKey="MY_COURSES"
                isExact={false}
                icon={<MyCoursesIconDark/>}
                selectedIcon={<MyCoursesIconLight/>}
                {...props}
              />

              <SingleMenu
                setSelectedMenu={setSelectedMenu}
              to="/surveys"
              title="Surveys"
              titleKey="Surveys"
              isExact={true}
              icon={<SurveyIconDark/>}
              selectedIcon={<SurveyIconLight/>}
              {...props}
            />
            <SingleMenu
              setSelectedMenu={setSelectedMenu}
              to="/support-ticket"
              title="Support"
              titleKey="Support"
              isExact={true}
              icon={<SupportIconDark/>}
              selectedIcon={<SupportIconLight/>}
              {...props}
            />
            <SingleMenu
              href="https://docs.learnify.ing"
              title="User Manual"
              titleKey="User Manual"
              target="_blank"
              icon={<MenuBookIcon/>}
              selectedIcon={<MenuBookIcon/>}
              {...props}
            />
            </Box>
          </Box>
          {openDrawerStatus && <Box>
              <Typography className='powered-by'>
                &copy; {t('Powered by')}&nbsp;
                <Link href="https://www.habilelabs.io/" rel="noopener noreferrer" target="_blank" id='habilelabs-text'>{t('HabileLabs')}</Link>
              </Typography>
          </Box>}
        </>
      }
    </React.Fragment>
  );
}

SingleMenu.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  openDrawerStatus: PropTypes.bool,
  screenWidth: PropTypes.number,
  handleDrawerClose: PropTypes.func,
  title: PropTypes.string,
  titleKey: PropTypes.string,
  icon: PropTypes.node,
  setSelectedMenu: PropTypes.func,
  selectedIcon: PropTypes.node,
  isExact: PropTypes.bool,
  target: PropTypes.string,
};

const useStyles = (themes) => {
  const themeData = localStorage.getItem('theme');
  const theme = JSON?.parse(themeData);
  let primaryFontText = "";
  if (theme !== undefined) {
    primaryFontText = JSON.parse(themeData)?.primaryFontColor;
  }
  return {
    navMenus: {
      '& a': {
        marginBottom: 5,
      },
      '& a.active': {
        background: ColorsConstant.activeBlue,
        transition: '.2s all linear',
      },
      '& a.active li': {
        color: primaryFontText,
      },
    },
    HeaderMenuButton: {
      backgroundColor: "transparent !important",
      float: "left",
      color: ColorsConstant.white,
      "@media (max-width: 1024px)": {
        marginTop: "10px",
      },
      "@media (max-width: 767px)": {
        color: "#2962ff",
        "& svg": {
          fontSize: 30,
          color: "#fff",
        },
      },
    },
    paper: {},
    drawer: {},
    drawerPaper: {},
    drawerPaperClose: {},
    drawerHeader: {},
    content: {},
    contentShift: {},
    menuButtonHidden: {},
    root: {},
    appBar: {},
    appBarShift: {},
    hide: {},
  };
};

TopMenuList.propTypes = {
  classes: PropTypes.shape({
    HeaderMenuButton: PropTypes.string,
    navMenus: PropTypes.string,
  }).isRequired,
  openDrawerStatus: PropTypes.bool,
  handleDrawerOpen: PropTypes.func,
  handleDrawerClose: PropTypes.func,
  screenWidth: PropTypes.number,
};

export default withStyles(useStyles, { withTheme: true })(TopMenuList);
